export const PREMIUM_PALETTES = [
  {
    name: "BetterChoice Original Rose",
    colors: {
      primary: "#C86B4C",         // Deepened Rose
      textOnPrimary: "#FFFFFF",   // High-contrast text for bubble
      secondary: "#9C442E",       // Rich Rust
      textOnSecondary: "#FFFFFF", // High-contrast text for bubble
      surface: "rgba(24, 20, 18, 0.85)", 
      accent: "#FFDAB9",
      textMain: "#FFFDFB",
      textMuted: "#E8DED5"
    }
  },
  {
    name: "Emerald Serenity (Clean Premium)",
    colors: {
      primary: "#059669",         // Deep Emerald
      textOnPrimary: "#FFFFFF",
      secondary: "#047857",       // Dark Teal
      textOnSecondary: "#FFFFFF",
      surface: "rgba(12, 16, 15, 0.9)",
      accent: "#34D399",
      textMain: "#F8FAFC",
      textMuted: "#CBD5E1"
    }
  },
  {
    name: "Midnight Tactical (Deep Contrast)",
    colors: {
      primary: "#0284C7",         // Rich Ocean Blue
      textOnPrimary: "#FFFFFF",
      secondary: "#0369A1",       // Deeper Navy
      textOnSecondary: "#FFFFFF",
      surface: "rgba(15, 23, 42, 0.95)",
      accent: "#38BDF8",
      textMain: "#FFFFFF",
      textMuted: "#E2E8F0"
    }
  },
  {
    name: "Oceanic Trust (Professional)",
    colors: {
      primary: "#2563EB",         // Royal Blue
      textOnPrimary: "#FFFFFF",
      secondary: "#1D4ED8",       // Deep Royal
      textOnSecondary: "#FFFFFF",
      surface: "rgba(8, 47, 73, 0.9)",
      accent: "#60A5FA",
      textMain: "#F8FAFC",
      textMuted: "#E0F2FE"
    }
  },
  {
    name: "Sunset Energy (Vibrant)",
    colors: {
      primary: "#EA580C",         // Deep Orange
      textOnPrimary: "#FFFFFF",
      secondary: "#C2410C",       // Burnt Orange
      textOnSecondary: "#FFFFFF",
      surface: "rgba(28, 25, 23, 0.95)",
      accent: "#FB923C",
      textMain: "#FAFAF9",
      textMuted: "#E7E5E4"
    }
  },
  {
    name: "Lavender Luxe (Holistic)",
    colors: {
      primary: "#7C3AED",         // Vibrant Purple
      textOnPrimary: "#FFFFFF",
      secondary: "#6D28D9",       // Deep Purple
      textOnSecondary: "#FFFFFF",
      surface: "rgba(30, 27, 75, 0.95)",
      accent: "#A78BFA",
      textMain: "#F8FAFC",
      textMuted: "#E0E7FF"
    }
  },
  {
    name: "Earthy Sage (Natural Balance)",
    colors: {
      primary: "#4D7C0F",         // Deep Sage
      textOnPrimary: "#FFFFFF",
      secondary: "#3F6212",       // Dark Forest
      textOnSecondary: "#FFFFFF",
      surface: "rgba(23, 23, 23, 0.9)",
      accent: "#A3E635",
      textMain: "#FAFAF9",
      textMuted: "#D6D3D1"
    }
  },
  {
    name: "Crimson Forge (Strength)",
    colors: {
      primary: "#BE123C",         // Deep Crimson
      textOnPrimary: "#FFFFFF",
      secondary: "#9F1239",       // Dark Rose
      textOnSecondary: "#FFFFFF",
      surface: "rgba(2, 6, 23, 0.95)",
      accent: "#FB7185",
      textMain: "#F9FAFB",
      textMuted: "#D1D5DB"
    }
  },
  {
    name: "Slate Monochrome (Minimal)",
    colors: {
      primary: "#475569",         // Deep Slate
      textOnPrimary: "#FFFFFF",
      secondary: "#334155",       // Dark Slate
      textOnSecondary: "#FFFFFF",
      surface: "rgba(15, 23, 42, 0.9)",
      accent: "#CBD5E1",
      textMain: "#F8FAFC",
      textMuted: "#94A3B8"
    }
  },
  {
    name: "Sapphire Glow (Tech Fitness)",
    colors: {
      primary: "#0891B2",         // Deep Cyan
      textOnPrimary: "#FFFFFF",
      secondary: "#0E7490",       // Dark Cyan
      textOnSecondary: "#FFFFFF",
      surface: "rgba(2, 6, 23, 0.92)",
      accent: "#22D3EE",
      textMain: "#F8FAFC",
      textMuted: "#CBD5E1"
    }
  }
];

/** Matches LandingPage.jsx / HomePage.jsx page backgrounds */
export const LAYOUT_PAGE_BG_DARK = 'bg-gradient-to-br from-slate-900 via-emerald-950 to-slate-900';
export const LAYOUT_PAGE_BG_LIGHT = 'bg-gradient-to-br from-emerald-50 via-teal-50 to-slate-100';

export function getLayoutPageBackgroundClass(isLightMode) {
  return isLightMode ? LAYOUT_PAGE_BG_LIGHT : LAYOUT_PAGE_BG_DARK;
}

export function buildLayoutThemeStyles(colors = {}) {
  return {
    '--theme-surface': colors.surface || 'rgba(24, 20, 18, 0.85)',
    '--theme-primary': colors.primary || '#E29578',
    '--theme-secondary': colors.secondary || '#3E3026',
    '--theme-accent': colors.accent || '#FFDAB9',
    '--theme-text': colors.textMain || '#FFFDFB',
    '--theme-text-muted': colors.textMuted || '#CDBBAA',
    '--theme-text-on-primary': colors.textOnPrimary || '#FFFFFF',
    '--theme-text-on-secondary': colors.textOnSecondary || '#FFFFFF',
  };
}